type IconProps = {
  className?: string;
};

export const Spinner = (props: IconProps) => (
  <svg
    className={`animate-spin ${props.className ?? ''}`}
    data-cy="spinner"
    fill="none"
    height="1em"
    viewBox="0 0 24 24"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM5.6 12C5.6 15.5346 8.46538 18.4 12 18.4C15.5346 18.4 18.4 15.5346 18.4 12C18.4 8.46538 15.5346 5.6 12 5.6C8.46538 5.6 5.6 8.46538 5.6 12Z"
      fill="transparent"
    />
    <path
      clipRule="evenodd"
      d="M4.60896 8.93853C4.20693 9.90914 4 10.9494 4 12H5.6C5.6 11.1595 5.76554 10.3273 6.08717 9.55083C6.4088 8.77434 6.88022 8.06881 7.47452 7.47452C8.06881 6.88022 8.77434 6.4088 9.55083 6.08717C10.3273 5.76554 11.1595 5.6 12 5.6C12.8405 5.6 13.6727 5.76554 14.4492 6.08717C15.2257 6.4088 15.9312 6.88022 16.5255 7.47452C17.1198 8.06881 17.5912 8.77434 17.9128 9.55083C18.1322 10.0803 18.2789 10.6358 18.3501 11.2021C18.4052 11.6405 18.7582 12 19.2 12C19.6418 12 20.0041 11.6409 19.96 11.2013C19.8821 10.4247 19.6908 9.66226 19.391 8.93853C18.989 7.96793 18.3997 7.08601 17.6569 6.34315C16.914 5.60028 16.0321 5.011 15.0615 4.60896C14.0909 4.20693 13.0506 4 12 4C10.9494 4 9.90914 4.20693 8.93853 4.60896C7.96793 5.011 7.08602 5.60028 6.34315 6.34315C5.60028 7.08601 5.011 7.96793 4.60896 8.93853Z"
      fill="url(#paint0_linear_811_23472)"
      fillRule="evenodd"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_811_23472"
        x1="12"
        x2="6.5"
        y1="4"
        y2="12.5"
      >
        <stop offset="0.22999" stopColor="currentColor" />
        <stop offset="0.78499" stopColor="currentColor" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
